/* eslint-disable react/require-default-props */
import React from 'react';
import { Form } from './styles';

interface AiManagementItemsSearchProps {
  value: string;
  showClear: boolean;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onClear: () => void;
  children?: React.ReactNode;
}

const AiManagementItemsSearch: React.FC<AiManagementItemsSearchProps> = ({
  value,
  showClear,
  onChange,
  onSubmit,
  onClear,
  children,
}) => (
  <Form
    className="d-flex align-items-center mb-3"
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
  >
    {children}
    <div className="search-box d-flex align-items-center flex-grow-1 bg-white border rounded">
      <input
        type="text"
        className="form-control border-0 bg-transparent shadow-none"
        placeholder="Buscar item"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {showClear ? (
        <button type="button" className="btn btn-link text-nowrap py-0" onClick={onClear}>
          Limpar
        </button>
      ) : null}
    </div>
    <button type="submit" className="btn btn-primary text-nowrap px-3 ml-4">
      Buscar
    </button>
  </Form>
);

export default AiManagementItemsSearch;
